import { Controller } from "@hotwired/stimulus";
import Dropzone from "dropzone";
import { DirectUpload } from "@rails/activestorage";
import axios from "axios";
import bootstrap_alert from "../bootstrap_alert";
import * as Sentry from "@sentry/browser";

export default class MyDropzone extends Controller {
  initialize() {
    // handle the data/variables from the view to be used in the following functions
    this.directUploadUrl = this.data.get("directUploadUrl");
    this.auth = this.data.get("auth");
    this.locale = this.data.get("locale");
    this.createAttachmentEndPoint = this.data.get("createAttachmentEndPoint");

    this.dropzone = new Dropzone("div#my-prettified-dropzone", {
      url: "https://httpbin.org/post",
      maxFilesize: "1000000000", // 1 GB
      clickable: true,
      uploadMultiple: true,
      acceptedFiles: "image/*, video/*, audio/*",
      parallelUploads: 2,
      headers: { "X-CSRF-Token": this.auth },
    });
  }

  connect() {
    this.dropzone.on("addedfile", (file) => {
      this.upload(file);
    });

    this.dropzone.on("complete", (file) => {
      setTimeout(() => {
        this.dropzone.removeFile(file);
      }, 3000);
    });

    I18n.locale = this.locale;
  }

  upload(file) {
    let upload = new DirectUpload(file, this.directUploadUrl, this);

    upload.create((error, blob) => {
      if (error) {
        // Handle the error
        bootstrap_alert.error(
          I18n.translate("stimulus.portfolio_editor.attachment_upload_failure"),
        );
        Sentry.captureException(error);
      } else {
        let bodyFormData = new FormData();
        bodyFormData.set(file.name, blob.signed_id);
        bodyFormData.append("portfolio_attachment[attachment]", file);
        bodyFormData.set("authenticity_token", this.auth);

        this.submitForm(bodyFormData);
      }
    });
  }

  async submitForm(bodyFormData) {
    try {
      await axios({
        method: "post",
        url: this.createAttachmentEndPoint,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRF-Token": this.auth,
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          // to render turbo response when use axios we have to call renderStreamMessage
          Turbo.renderStreamMessage(response.data);
          bootstrap_alert.notice(
            I18n.translate(
              "stimulus.portfolio_editor.attachment_upload_success",
            ),
          );
        } else {
          bootstrap_alert.error(
            I18n.translate(
              "stimulus.portfolio_editor.attachment_upload_failure",
            ),
          );
          Sentry.captureMessage("error while adding portfolio attachments!");
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  disconnect() {
    this.dropzone.destroy();
  }
}
